import { SPONSORED_DAY_VIEW_TYPES } from '@web-platform/shared-universal-constants/src/adverts';
import { GLOBAL } from 'saddlebag-browser';
import { FunnelEventsTracking } from 'saddlebag-user-tracking-events';
import { v4 as uuid } from 'uuid';

const AD_SPONSORED_SEARCH = 'sponsored.AdSponsoredSearch';

const SPONSORED_EVENT_TYPE_MAP: Record<string, number> = {
  [SPONSORED_DAY_VIEW_TYPES.FILTERED]: 1,
  [SPONSORED_DAY_VIEW_TYPES.DESTINATION]: 2,
};

export const emitAdSponsoredSearchEvent = (viewId: string): void => {
  const $window = GLOBAL.getWindow();
  const sponsoredContent = $window.__internal?.sponsoredContent;
  if (!sponsoredContent) return;

  const tracker = new FunnelEventsTracking('public', 'acorn');

  tracker.track(
    AD_SPONSORED_SEARCH,
    {
      adSearchEventType: SPONSORED_EVENT_TYPE_MAP[sponsoredContent.type] ?? 0,
      campaignId: sponsoredContent.payload?.campaignId ?? '',
      searchGuid: viewId,
    },
    { messageGuid: uuid() },
  );
};
